export type SessionStorage = typeof window.sessionStorage;

/**
 * wrapper for window.sessionStorage to make it easier replaceable in unit
 * tests
 */
export const SessionStorageProvider = {
  provide: 'sessionStorage',
  // eslint-disable-next-line angular/window-service
  useFactory: () => window.sessionStorage,
};
